<template lang="pug">
.slots-date(v-if="reservedExamInDateCount")
  .slots-date__header
    span.slots-date__title {{ date | DOWDutch }} {{ date | formattedDate }} - {{ reservedExamInDateCount }}
  location(
    v-for="(slotItem, name, index) in item" 
    :location="name" 
    :key="index" 
    :items="slotItem" 
    :date="date"
  )
</template>

<script>
import { dateFormating, getDOW } from '@/util'
import { RESERVED_TYPE } from '../core/reserved-const'
import { ACTIVE_TYPE } from '../../slots/core/slots-conts'
export default {
  props: {
    item: Object,
    date: String
  },

  inject: ['topActive', 'mijnActive', 'allActive'],

  mounted() {
  },

  computed: {

    reservedExamInDateCount() {
      return Object.values(this.item).reduce((acc, dateItems) => {
        let items
        if(this.isAllActive) items = dateItems 
        else if(this.isTopActive) items = dateItems.filter(item => item.type === RESERVED_TYPE.TOP)
        else if(this.isMijnActive) items = dateItems.filter(item => item.type === RESERVED_TYPE.MIJN)
        let count = items.reduce( (reservedAcc, reservedExam) => reservedAcc + reservedExam.quantity, 0)
        return acc + count
      } , 0)
    },

    isTopActive() {
      return this.topActive()
    },

    isAllActive() {
      return this.allActive()
    },

    isMijnActive() {
      return this.mijnActive()
    },
  },

  components: {
    location: () => import('./ReservedLocation.vue'),
  }
}
</script>

<style lang="scss" scoped>
.slots-date {
  margin: 0 16px;
  border: 1px solid $border-color;
  &__header {
    background-color: #E5E5E5;
    padding: 16px 8px;
  }
  &__title {
    font-weight: 500;
  }
}
</style>